import React, { useEffect, useState } from 'react';

// === STYLE / MATERIAL UI ===
import { Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText, Button } from '@mui/material';

// === COMPONENTS ===
import { useTaskComplete } from 'components/useTaskComplete';

// === API ===
import { submitTask } from 'api/prokey/prokey.websocket';

//-----------------------------------------------------------------
function TaskCompleteModal() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const completion_status = useTaskComplete();

  const [     showModal, setShowModal     ] = useState(false);
  const [hasClosedModal, setHasClosedModal] = useState(false);
  
  //#endregion

  //#region [EFFECT]

  useEffect(() => {
    if (!completion_status.is_complete) {
      setHasClosedModal(false);
      setShowModal(false);
      return;
    }

    const is_auto_mode = localStorage.getItem('auto-mode') === 'true';
    const is_batch_auto_submit = localStorage.getItem('setting-task-submit') === '1';
    if (is_auto_mode || is_batch_auto_submit) {
      setShowModal(false);
      submitTask();
      return;
    }

    const modalTimeout = setTimeout(() => setShowModal(!hasClosedModal), 100);
    document.addEventListener('keydown', onKeyDown);

    return () => {
      clearTimeout(modalTimeout);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [completion_status, hasClosedModal]);

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onKeyDown(event) {
    //-----------------------------------------------------------------
    if (event.key === 'Enter' && event.altKey) {
      submitTask();
    }
  }

  //-----------------------------------------------------------------
  function handleClose() {
    //-----------------------------------------------------------------
    setHasClosedModal(true);
    setShowModal(false);
  }

  //-----------------------------------------------------------------
  function handleSubmit() {
    //-----------------------------------------------------------------
    submitTask();
    setShowModal(false);
  }
  
  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return showModal ? (
      <Dialog open={showModal} onClose={handleClose}>
        <DialogTitle>{completion_status.empty_qc ? 'No Reviewable QC Fields' : 'Finished Processing Task'}</DialogTitle>
        <DialogContent>
          {completion_status.empty_qc ? (
            <DialogContentText>
              This QC task has no reviewable fields in its configured scope. Click 'Submit' to continue its normal workflow, or 'Close' to keep the task open.
            </DialogContentText>
          ) : (
            <>
              <DialogContentText>
                If you'd like to complete this task click 'Submit', otherwise click 'Close' to go back and review the task.
              </DialogContentText>
              <DialogContentText>
                If you don't see any fields you may need to set the correction mode to 'Show All Fields'.
              </DialogContentText>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button name='back_to_task_btn' onClick={handleClose} color='primary'>
            Close
          </Button>
          <Button name='submit_task_btn' onClick={handleSubmit} color='primary'>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    ) : null;
  }

  //#endregion

  return display();
}

export { TaskCompleteModal };
